export default __webpack_public_path__ + "static/media/img6.0f41a36e.jpeg";